import { type InputHTMLAttributes, type ReactNode, type Ref } from 'react'

import { extractInputProps, type InputProps } from '@/defs/input'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './InputText.module.scss'

type BaseProps = {
  affix?: ReactNode
  label?: string
  onChange?: (value: string) => void
  ref?: Ref<HTMLInputElement>
}

type Props = BaseProps &
  InputProps &
  DistributiveOmit<InputHTMLAttributes<HTMLInputElement>, keyof BaseProps | keyof InputProps | 'className'>

export const InputText = ({ affix, label, onChange, ref, required, value, ...props }: Props) => {
  const isEmpty = value === '' || value === 0
  const { inputProps, rest } = extractInputProps(props)

  return (
    <label className={cn(styles.container, { hasLabel: !!label, isEmpty, ...inputProps, styles })}>
      {label && (
        <div className={styles.label}>
          {label}
          {required && <strong>*</strong>}
        </div>
      )}
      <div className={styles.field}>
        {affix && <div className={styles.affix}>{affix}</div>}
        <input
          className={cn(styles.input, { isEmpty, styles })}
          onChange={(e) => onChange && onChange(e.currentTarget.value)}
          ref={ref}
          required={required}
          value={value !== undefined ? value : ''}
          {...rest}
        />
      </div>
    </label>
  )
}
